import { useSetting } from "@/hooks/useSetting";
import { FC, useCallback, useEffect, useState } from "react";

import imgSetup from "@/assets/tipeee-setup.png";
import { TipeeeAccessTokenSetting } from "@ailenax-overlay/shared";

export const Tipeee: FC = () => {
    const [settings, setSettings] = useSetting("tipeee-access-token");
    const [value, setValue] = useState<TipeeeAccessTokenSetting["type"]>(settings);

    useEffect(() => {
        setValue(settings);
    }, [settings]);

    const handleSave = useCallback(() => {
        setSettings(value);
    }, [value, setSettings]);

    return (
        <div className="max-h-screen min-w-xl flex flex-col items-center justify-center">
            <h1 className="text-4xl text-center" aria-label="Tipee Setup">
                Tipeee Setup
            </h1>
            <p className="text-center mt-4">
                To set up the Tipeee integration, you need to enter your <strong>Tipeee Username</strong> and your <strong>API Key</strong> from your <a href="https://www.tipeeestream.com/dashboard/api-key/" target="_blank" rel="noopener noreferrer" className="underline">Tipeee API settings</a> below:<br/>
            </p>
            <div className="flex flex-col gap-2 items-center justify-center mt-4 w-full max-w-md">
                <input
                    type="text"
                    className="p-2 border rounded w-full max-w-md"
                    placeholder="Enter your Tipeee Username"
                    value={value?.username ?? ""}
                    onChange={(e) => setValue(prev => ({ username: e.target.value, apiToken: prev?.apiToken ?? "" }))}
                />
                <input
                    type="text"
                    className="p-2 border rounded w-full max-w-md"
                    placeholder="Enter your Tipeee API Key"
                    value={value?.apiToken ?? ""}
                    onChange={(e) => setValue(prev => ({ username: prev?.username ?? "", apiToken: e.target.value }))}
                />
                <button
                    className="px-4 py-2 bg-violet-500 text-white rounded hover:bg-violet-600 transition"
                    onClick={handleSave}
                >
                    Save
                </button>
            </div>
            <p className="text-center mt-4">
                You can find this token in your Tipeee API settings under the "YOUR API KEY" section.<br/>
            </p>
            <img src={imgSetup} alt="Screenshot showing where to find the Tipeee API token in the Tipeee API settings" className="w-1/2 mt-12 rounded shadow-lg" />
            <p className="text-center mt-4">
                After entering your username and API key, your overlay should be able to receive donations from Tipeee.<br/>
            </p>
        </div>
    );
}